import type { Maybe } from '@adornis/base/utilTypes.js';
import { Int } from '@adornis/baseql/baseqlTypes.js';
import { Field } from '@adornis/baseql/decorators/field.js';
import { Entity } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import type { BillingRhythm } from './BillingPosition.js';

@Entity()
export class BillingPositionTemplate extends MongoEntity {
  static override _class = 'BillingPositionTemplate';
  static override _collectionName = 'billing-position-templates';

  constructor(doc: Partial<BillingPositionTemplate>) {
    super(doc);
  }

  @validate(nonOptional())
  @Field(() => String)
  public name: Maybe<string>;

  @validate(nonOptional())
  @Field(() => String)
  public kuerzel: Maybe<string>;

  @Field(() => String)
  public rhythm: Maybe<BillingRhythm>;

  @Field(() => Int)
  public priceInCents: Maybe<number>;

  /**
   * In which scope will this template be shown? Empty is global
   */
  @Field(() => String)
  public scope: Maybe<string>;
}
